import NavbarVertical from 'components/navbar/vertical/NavbarVertical';
import React from 'react';
import ModalAuth from 'components/authentication/modal/ModalAuth';
import VerticalLayoutNavbarTop from 'components/navbar/top/VerticalLayoutNavbarTop';
import { Outlet } from 'react-router-dom';

const VerticalNavLayout = () => {
  return (
    <div className="container">
      <NavbarVertical />
        <div className="content">
          <VerticalLayoutNavbarTop />
          <Outlet />
        </div>
      <ModalAuth />
    </div>
  );
};

export default VerticalNavLayout;
